module.exports = __webpack_public_path__ + "static/media/MMS_MM_Beyond-the-EHR_WP.3ab83d12.pdf";